<ul class="knowledge-tag">
  <li *ngFor="let tag of data">{{tag}}</li>
</ul>
